import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
const { v4: uuid } = require('uuid');

const useStyles = makeStyles((theme) => ({
    table: {
        width: '100%',
        textAlign: 'center',
        borderCollapse: 'collapse',
    },
    MuiTableCell: {
        textAlign: 'center',
        border: '2px solid black',
        fontWeight: 'bold',
    },
    tableStle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '100%',
    },
    tableContainer: {
        width: '30%',
        minWidth: 250,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            minWidth: 0,
            maxWidth: 280,
        },
    },
}));

const DynamicReport = ({ allwords, heading }) => {
    const classes = useStyles();
    return (
        <div className={classes.tableStle}>
            <h4>{heading}</h4>
            <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                        {[
                            ['Initiating', 1],
                            ['Emerging', 2],
                            ['Performing', 3],
                            ['Advancing', 4],
                            ['Leading', 5],
                        ].map(([label, value]) => (
                            <TableRow key={uuid()}>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.MuiTableCell}>
                                    {label}
                                </TableCell>
                                <TableCell align="right" className={classes.MuiTableCell}>
                                    {value}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default DynamicReport;
